import React, {Component} from 'react';

import Date from '../../../shared/components/Moment/Date.jsx';

import './Moderations.scss';

export default class ModerationsLoaded extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12">
          <table className="table table-striped table-dark w-100">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Modérateur</th>
                <th scope="col">Description</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {
                this.props.history.map((history) => {
                  return (
                    <tr key={history.id}>
                      <th scope="row">{history.id}</th>
                      <td>{history.moderator ? history.moderator.fullname : 'n/a'}</td>
                      <td>{history.description}</td>
                      <td><Date format="dd/MM/yyyy HH:mm" date={history.created_at} /></td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}